import { Box } from "@material-ui/core";
import { useUndoCancelCipOrderLinesMutation } from "@saleor/graphql";
import useNotifier from "@saleor/hooks/useNotifier";
import getErrorOutDated from "@saleor/utils/errors/outDated";
import React from "react";

const useUndoCancellation = ({
  orderId: soNo,
  resetSubmitState,
  refetchChangeOrderData,
  setSubmitState,
  totalItemsOriginal
}) => {
  const notify = useNotifier();
  const showErrorNotification = (OrderErrors, ItemErrors, source) => {
    notify({
      status: "error",
      title: "Something went wrong",
      text: (
        <>
          <Box>
            <b>{`Error  ${source}`}</b>
          </Box>
          <Box>{`${OrderErrors}  ${ItemErrors}`}</Box>
        </>
      )
    });
  };
  const [undoCancelCipOrderLines] = useUndoCancelCipOrderLinesMutation({});
  const confirmUndoCancel = itemNo => {
    setSubmitState({ state: "processing" });
    undoCancelCipOrderLines({
      variables: {
        soNo,
        itemNo,
        totalItems: totalItemsOriginal
      }
    }).then(res => {
      if (res?.data?.undoCancelCipOrderLines?.warningMessages?.length) {
        const fmtMessage = item => {
          const title = item.order || item.itemNo;
          return title ? `${title} - ${item.message}` : item.message;
        };
        notify({
          title: "Warning",
          status: "warning",
          apiMessage: res?.data?.undoCancelCipOrderLines?.warningMessages
            ?.map(fmtMessage)
            .join("\n"),
          autohide: null
        });
      }
      if (res?.data?.undoCancelCipOrderLines?.success) {
        refetchChangeOrderData();
        resetSubmitState();
      } else {
        resetSubmitState();
        const errors = res?.data?.undoCancelCipOrderLines;
        const sapErrorOrders = errors?.sapOrderMessages?.map(
          ({ errorCode, errorMessage }) =>
            `${errorCode || ""} - ${errorMessage}`
        );
        const sapErrorItems = errors?.sapItemMessages?.map(
          ({ itemNo, errorMessage, errorCode }) =>
            `${itemNo || ""} ${errorCode || ""} - ${errorMessage}`
        );
        if (sapErrorItems?.length > 0 || sapErrorOrders?.length > 0) {
          showErrorNotification(sapErrorOrders, sapErrorItems, "SAP");
        }
        const errorOutDated = getErrorOutDated(errors);
        if (errorOutDated) {
          setSubmitState({
            state: "errorPopup",
            context: errorOutDated
          });
        }
      }
    });
  };
  return { confirmUndoCancel };
};
export default useUndoCancellation;
